import { Actions, ofType, createEffect } from '@ngrx/effects';
import { inject, Injectable } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { CalendarService } from '@app/common/services/calendar.service';
import { TaskService } from '@app/common/services/task.service';
import {  CalendarState,  InitialCalendarState, selectedCalendarState } from './state';
import { DisplayAllAttributesAction, CalendarActionType,  GetEventsByModelAction,
    GetEventsByModelDoneAction, GetStructureModelAction, GetStructureModelDoneAction,
     GetDistinctUsersSortimenteAction, GetDistinctUsersSortimenteActionDone } from './actions';
import { withLatestFrom, switchMap, map, tap } from 'rxjs/operators';
import { selectAllAttributes } from './selectors';
import { Observable, of } from 'rxjs';
import { CalendarDataModel } from '@app/common/models/CalendarData.model';


@Injectable()
export class CalendarEffects {
  
    private state$ : Observable<CalendarState> = of (InitialCalendarState) ;
    actions = inject(Actions);

    constructor(
        private store: Store<any>,
        private service: CalendarService,
        private taskService: TaskService,
      
      ) {

        this.state$ = this.store.pipe(select(selectedCalendarState));

         }




    getEventsByModel$ = createEffect(() => { return  this.actions.pipe(
        ofType<GetEventsByModelAction>(CalendarActionType.GetEventsByModel),
        withLatestFrom(this.state$),
        tap(console.log.bind(window)),
        switchMap(([action, state]) => this.service.getEventsByModel( action.payload.queryModel )),
        map(response => new GetEventsByModelDoneAction({ dataModel: response }))
    )})



    GetDistinctUsersSortimente$ = createEffect(() => { return  this.actions.pipe(
        ofType<GetDistinctUsersSortimenteAction>(CalendarActionType.GetDistinctUsersSortimente),
        withLatestFrom(this.state$),
        tap(console.log.bind(window)),
        switchMap(([action, state]) => this.service.GetDistinctUsersSortimente(action.payload.queryModel  )),
        map(response => new GetDistinctUsersSortimenteActionDone({ array: response }))
    )})



    getStructureModel$ = createEffect(() => { return  this.actions.pipe(
        ofType<GetStructureModelAction>(CalendarActionType.GetStructureModel),
        withLatestFrom(this.state$),
        switchMap(([action, state]) => this.service.getFilterStructureModel()),
        map(response => new GetStructureModelDoneAction({ structureModel: response }))
    )})




}
